<template>
  <div>
    <el-dialog
    :append-to-body="true"
      title="分配权限"
      :visible.sync="assignDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="closeDialog">
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form" >
        <!-- <el-form-item label="菜单id" prop="btnId">
          <el-input v-model="form.btnId" autocomplete="off" placeholder="请输入" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="权限名" prop="accessIds">
          <el-select
          style="width:100%;"
          class="sel"
          ref="deviceScope"
          v-model="form.accessIds"
          :multiple="true"
          filterable
          @focus="focusStatus&&openDrawer()">
            <el-option
              v-for="item in charactorOptions"
              :key="item.accessId"
              :label="item.accessName"
              :value="item.accessId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <Drawer
    v-if="drawerFlag"
    :accessData="accessData"
    :btnId="btnId"
    :drawerFlag="drawerFlag"
    @closeDrawer = "closeDrawer"
    @getData="receive"/>
  </div>
</template>
<script>
import { listByButtonId } from '@/api/permissionManager'
import { bindAccess } from '@/api/buttons'
import Drawer from './drawer'
export default {
  props: {
    assignDialogVisible: {
      type: Boolean,
      default: false
    },
    btnId: {
      type: Number
    }
  },
  data () {
    return {
      form: {},
      rules: {},
      charactorOptions: [],
      // 抽屉
      drawerFlag: false,
      focusStatus: true,
      accessData: []
    }
  },
  created () {
    this.form.btnId = this.btnId
    // this.getRoleList()
    this.getRoleByBtnId()
  },
  components: {
    Drawer
  },
  methods: {
    // 打开抽屉
    openDrawer () {
      this.drawerFlag = true
      this.$refs.deviceScope.blur()
      this.focusStatus = false
      this.accessData = Object.assign([], this.charactorOptions)
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取子组件数据
    receive (val) {
      console.log('子组件数据', val)
      this.charactorOptions = val
      this.form.accessIds = val.map(res => res.accessId)
      this.drawerFlag = false
      this.focusStatus = true
    },
    /* getRoleList () {
      const params = {
        pageSize: 100
      }
      list(params).then((res) => {
        this.charactorOptions = res.data.data.list
      })
    }, */
    getRoleByBtnId () {
      const params = {
        buttonId: this.btnId
      }
      listByButtonId(params).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          if (res.data.data.length > 0) {
            this.form.accessIds = res.data.data.map(v => v.accessId)
            this.charactorOptions = res.data.data
          } else {
            return false
          }
        }
      })
    },
    closeDialog () {
      this.$emit('closeAssignDialog')
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const accessIds = this.form.accessIds.join(',')
          const params = {
            buttonId: this.form.btnId,
            accessIds: accessIds
          }
          bindAccess(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '权限分配成功'
              })
              this.$emit('closeAssignDialog', 1)
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .sel{
    /deep/ .el-icon-close{
      display: none;
    }
  }

  /deep/ .el-select-dropdown{
    z-index: 0;
    display: none;
  }
</style>
